import { cancelFixedOnTop, fixedOnTop, getMenuList, removeConversation } from '@/api/glms'
import { DIALOG_MODE, COMPONENT_TYPE } from '@/components/glms/js/const'
import { getPromptByStructure, PromptParseErrorMsg } from '@/components/glms/js/openingUi'
import omit from 'lodash/omit'

const glms = {
  namespaced: true,

  state: {
    activeTab: 'create',
    assistantInfo: {},
    api: {
      apiList: [],
      templateList: []
    },
    urlAssistantId: '',
    editActionStatus: false,
    localPrompt: '',
    recentUsedList: [],
    sidebarList: [],
    hasUpdated: false,
    hasActionUpdated: false,
    draftId: '',
    errorInfo: {},
    showToolCenterGuide: false,
    actionIndex: '',
    actionObj: {
      auth: {
        type: 'none'
      }
    },
    schemaValid: true,
    tempId: '',
    knowledgeId: '',
    defaultStoredAvatar: '',
    editTemplateSchema: false,
    shareLoginedRedirectPath: '', // 分享登录成功之后重定向的路径
    createGmlsConfig: {
      GLMs_info: []
    }, // 新建智能体配置信息
    getAssistInfoLoading: false, // 获取智能体信息接口正在请求中 loading
    getWelComeConfigLoading: false // 获取欢迎页配置信息接口正在请求中 loading
  },

  mutations: {
    SET_ASSIST_INFO_LOADING: (state, value) => {
      state.getAssistInfoLoading = value
    },
    SET_WELCOME_CONFIG_LOADING: (state, value) => {
      state.getWelComeConfigLoading = value
    },
    SET_SCHEMA_VALID: (state, value) => {
      state.schemaValid = value
    },
    SET_EDIT_TEMPLATE_SCHEMA: (state, value) => {
      state.editTemplateSchema = value
    },
    SET_CREATE_GMLS_CONFIG: (state, value) => {
      state.createGmlsConfig = value
    },
    SET_SHARE_LOGINED_REDIRECT_PATH(state, shareLoginedRedirectPath) {
      state.shareLoginedRedirectPath = shareLoginedRedirectPath
    },
    SET_ACTION_OBJ: (state, actionObj) => {
      state.actionObj = actionObj
    },
    SET_API: (state, apiObj) => {
      state.api = apiObj
    },

    SET_KNOWLEDGE_ID: (state, knowledgeId) => {
      state.knowledgeId = knowledgeId
    },
    SET_TEMP_ID: (state, tempId) => {
      state.tempId = tempId
    },
    SET_SHOW_TOOLCENTERGUIDE: (state, showToolCenterGuide) => {
      state.showToolCenterGuide = showToolCenterGuide
    },
    SET_ERROR_INFO: (state, errorInfo) => {
      state.errorInfo = errorInfo
    },
    RESET_STATUS: state => {
      state.localPrompt = ''
      state.hasUpdated = false
      state.hasActionUpdated = false
      state.draftId = ''
      state.editActionStatus = false
      state.editTemplateSchema = false
      state.actionObj = {}
      state.tempId = ''
      state.knowledgeId = ''
      state.defaultStoredAvatar = ''
      //   state.createGmlsConfig = {}
    },
    SET_DEFAULT_AVATAR: (state, defaultStoredAvatar) => {
      state.defaultStoredAvatar = defaultStoredAvatar
    },
    SET_RECENT_LIST: (state, recentUsedList) => {
      state.recentUsedList = recentUsedList
    },
    SET_SIDEBAR_LIST: (state, sidebarList) => {
      state.sidebarList = sidebarList
    },
    SET_ACTIVE_TAB: (state, activeTab) => {
      state.activeTab = activeTab
    },
    SET_ASSISTANT_INFO: (state, assistantInfo) => {
      state.assistantInfo = assistantInfo
    },
    SET_ASSISTANT_ID: (state, urlAssistantId) => {
      state.urlAssistantId = urlAssistantId
    },
    RESET_ASSISTANT_UI_COMPS: state => {
      state.assistantInfo = {
        ...state.assistantInfo,
        opening_ui: {
          ...state.assistantInfo.opening_ui,
          components: (state.assistantInfo.opening_ui?.components || []).map(comp => {
            if (comp.type === COMPONENT_TYPE.paragraph) {
              return comp
            }
            return omit(comp, ['content'])
          })
        }
      }
    },
    SET_EDIT_ACTION_STATUS: (state, editActionStatus) => {
      state.editActionStatus = editActionStatus
    },
    SET_LOCAL_PROMPT: (state, localPrompt) => {
      state.localPrompt = localPrompt
    },
    SET_UPDATE_TIME: (state, updated_at) => {
      state.assistantInfo.updated_at = updated_at
    },
    SET_HAS_UPDATED: (state, hasUpdated) => {
      state.hasUpdated = hasUpdated
    },
    SET_HAS_ACTION_UPDATED: (state, hasActionUpdated) => {
      state.hasActionUpdated = hasActionUpdated
    },
    SET_DRAFT_ID: (state, draftId) => {
      state.draftId = draftId
    },
    SET_ACTION_INDEX: (state, actionIndex) => {
      state.actionIndex = actionIndex
    }
  },
  actions: {
    async setTop({ dispatch }, params) {
      try {
        await fixedOnTop(params)
        await dispatch('getMenuList')
      } catch (error) {
        console.log(error)
      }
    },
    async cancelTop({ dispatch }, params) {
      try {
        await cancelFixedOnTop(params)
        await dispatch('getMenuList')
      } catch (error) {
        console.log(error)
      }
    },
    async deleteConversation({ dispatch }, params) {
      try {
        await removeConversation(params)
        await dispatch('getMenuList')
      } catch (error) {
        console.log(error)
      }
    },
    async getMenuList({ commit }) {
      try {
        const { result } = await getMenuList()
        commit('SET_SIDEBAR_LIST', result.top_list)
        commit('SET_RECENT_LIST', result.normal_list)
      } catch (error) {
        console.log(error)
      }
    }
  },
  getters: {
    assistantId(state) {
      return state.urlAssistantId || state.assistantInfo.assistant_id
    },
    uiComponents(state) {
      if (state.assistantInfo.chat_mode === DIALOG_MODE.opening_ui) {
        return state.assistantInfo.opening_ui?.components || []
      }
      return []
    },
    uiDefaultPrompt(state, getters) {
      const comps = getters.uiComponents
      if (comps.length > 0) {
        const initialPrompt = comps
          .filter(item => item.type !== COMPONENT_TYPE.paragraph)
          .map(item => {
            const curKey = item.key
            return `${item.title}{{${curKey}}}`
          })
          .join('')
        return initialPrompt
      }
      return ''
    },
    promptPureText(state, getters) {
      const promptStructure =
        state.assistantInfo.opening_ui?.opening_prompt || getters.uiDefaultPrompt
      return getPromptByStructure(promptStructure, getters.uiComponents)
    },
    promptParsError(state, getters) {
      return getters.promptPureText.includes(PromptParseErrorMsg)
    }
  }
}

export default glms
